/**
 * Componente de botón de micrófono (click-to-record)
 * Click para iniciar grabación, click para detener y enviar
 */

import { useVoiceRecorder } from '../../hooks/useVoiceRecorder';
import { useAvatarAnimation } from '../../hooks/useAvatarAnimation';
import { useEffect } from 'react';
import './MicrophoneButton.css';

interface MicrophoneButtonProps {
  onRecordingComplete?: (audioBlob: Blob) => void;
}

export function MicrophoneButton({ 
  onRecordingComplete
}: MicrophoneButtonProps) {
  const { isRecording, startRecording, stopRecording } = useVoiceRecorder();
  const { setListening } = useAvatarAnimation();

  // Activar/desactivar animación de listening cuando cambia el estado de grabación
  useEffect(() => {
    setListening(isRecording);
  }, [isRecording, setListening]);

  const handleClick = async () => {
    try {
      if (!isRecording) {
        // Iniciar grabación
        await startRecording();
      } else {
        // Detener grabación y enviar
        const audioBlob = await stopRecording();
        if (audioBlob && onRecordingComplete) {
          onRecordingComplete(audioBlob);
        }
      }
    } catch (error) {
      console.error('Error al manejar grabación:', error);
    }
  };

  return (
    <button
      className={`microphone-button ${isRecording ? 'recording' : ''}`}
      onClick={handleClick}
      aria-label={isRecording ? 'Click para detener y enviar' : 'Click para grabar'}
    >
      <img 
        src="/assets/ui/iconos/Mic.png" 
        alt="Micrófono" 
        className="mic-icon"
      />
      {isRecording && (
        <div className="recording-indicator">
          <img 
            src="/assets/ui/iconos/Audio.png" 
            alt="Grabando" 
            className="audio-icon"
          />
        </div>
      )}
    </button>
  );
}


